import { defineAbility } from '@casl/ability';

export const AdminAbilities = defineAbility((can, cannot) => {
    can(['', 'create', 'update', 'delete'], 'Customer');
    cannot([], 'Customer');

    can(['read', 'create', 'update', 'delete'], 'Document');
    cannot([], 'Document');

    can(['read', 'create', 'update', 'delete'], 'ProductAnalysis');
    cannot([], 'ProductAnalysis');

    can(['read'], 'ProductAnalysisAudit');
    cannot([], 'ProductAnalysisAudit');

    can(['read', 'create', 'update', 'delete'], 'Analysis');
    cannot([], 'Analysis');
});

export const ParalegalAbilities = defineAbility((can, cannot) => {
    can([''], 'Customer');
    cannot(['read', 'create', 'update', 'delete'], 'Customer');

    can([''], 'Document');
    cannot(['read', 'create', 'update', 'delete'], 'Document');

    can(['read', 'update'], 'ProductAnalysis');
    cannot(['create', 'delete'], 'ProductAnalysis');

    can(['read', 'update'], 'Analysis');
    cannot([''], 'Analysis');
});

export const DocReviewAbilities = defineAbility((can, cannot) => {
    can([''], 'Customer');
    cannot(['read', 'create', 'update', 'delete'], 'Customer');

    can(['read', 'create', 'update', 'delete'], 'Document');
    cannot([''], 'Document');

    can(['read', 'create', 'update'], 'ProductAnalysis');
    cannot(['delete'], 'ProductAnalysis');

    can(['read', 'create', 'update'], 'Analysis');
    cannot([''], 'Analysis');
});

export const DefaultAbilities = defineAbility((can, cannot) => {
    can([''], 'Customer');
    cannot(['read', 'create', 'update', 'delete'], 'Customer');

    can([''], 'Document');
    cannot(['read', 'create', 'update', 'delete'], 'Document');

    can([''], 'ProductAnalysis');
    cannot(['read', 'create', 'update', 'delete'], 'ProductAnalysis');

    can([''], 'Analysis');
    cannot(['read', 'update'], 'Analysis');
});
